import { useKeycloak } from '@react-keycloak/web';
import Inicio from '../../views/Inicio/Inicio';
import Calendario from '../../views/Calendario/Calendario';
import Regulamento from '../../views/Regulamento/Regulamento';
import RelatorioEscolasPublico from '../../views/Relatorio/EscolasPublico';

export const path = '';

export const mainPage = '/';

export const listRoutes = [
    {
        path: path + '/',
        component: Inicio,
        roles: [],
    },
];

export const listRoutesParty = [
    {
        path: path + '/regulamento',
        component: Regulamento,
        roles: null,
    },
    {
        path: path + '/calendario',
        component: Calendario,
        roles: null,
    },
    {
        path: path + '/escolas',
        component: RelatorioEscolasPublico,
        roles: null,
    },
]

export const GoToLogin = () => {
    const [keycloak, initialized] = useKeycloak();
    
    return initialized && !keycloak.authenticated && keycloak.login({ redirectUri: process.env.REACT_APP_PUBLIC_URL })
}

export default listRoutes;